import { jsx as _jsx } from "react/jsx-runtime";
import { IconPrimitive } from '#pplx/frontend/aether/primitives/IconPrimitive/index.js';
import { useReducedMotion } from '#pplx/frontend/common/hooks/useReducedMotion.js';
import { ComposerContainerContext } from '#pplx/frontend/composer-sdk/ComposerContainerContext.js';
import { COMPOSER_MOTION_SPRING } from '#pplx/frontend/composer-sdk/composerMotion.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { animated, useSpring } from '@react-spring/web';
import { useContext, useMemo } from 'react';
import { useIntl } from 'react-intl';
/** Keeps the framed close glyph and its accessible name in sync; callers own the Add label. */
export function useComposerPlusIcon(expanded) {
    const { $t } = useIntl();
    const { isFramed } = useContext(ComposerContainerContext);
    const isCloseAffordance = isFramed && expanded;
    const reducedMotion = useReducedMotion();
    const { rotation } = useSpring({
        rotation: isCloseAffordance ? 45 : 0,
        config: COMPOSER_MOTION_SPRING,
        immediate: reducedMotion || !isFramed,
    });
    const glyph = useMemo(() => function PlusGlyph({ size, strokeWidth, className, 'aria-hidden': ariaHidden }) {
        return (_jsx(animated.span, { className: "inline-flex", style: { transform: rotation.to((angle) => `rotate(${angle}deg)`) }, children: _jsx(IconPrimitive, { icon: $icon('custom-plus-large'), size: typeof size === 'number' ? size : 'inherit', strokeWidth: typeof strokeWidth === 'string' ? Number(strokeWidth) : strokeWidth, className: className, "aria-hidden": ariaHidden === true || ariaHidden === 'true' }) }));
    }, [rotation]);
    return {
        icon: isFramed ? glyph : $icon('custom-plus-large'),
        closeLabel: isCloseAffordance
            ? $t({
                defaultMessage: 'Close',
                description: 'Aria label for closing the composer plus menu',
                id: 'cb490ddd5a',
            })
            : undefined,
    };
}
//# sourceMappingURL=ComposerPlusIcon.js.map